
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"23","height":"23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)","fill":"#3CA1F5","stroke":"#3CA1F5","stroke-miterlimit":"10"}},[_c('path',{attrs:{"d":"M11.301 21.692c-5.76 0-10.44-4.68-10.44-10.44S5.541.812 11.301.812s10.44 4.68 10.44 10.44-4.69 10.44-10.44 10.44zm0-20.31c-5.44 0-9.87 4.43-9.87 9.87 0 5.44 4.43 9.87 9.87 9.87 5.44 0 9.87-4.43 9.87-9.87 0-5.44-4.43-9.87-9.87-9.87z"}}),_c('path',{attrs:{"d":"M11.301 7.871c-.61 0-1.11-.5-1.11-1.11 0-.61.5-1.11 1.11-1.11.61 0 1.11.5 1.11 1.11 0 .61-.5 1.11-1.11 1.11zm0-1.65c-.3 0-.54.24-.54.54 0 .3.24.54.54.54.3 0 .54-.24.54-.54 0-.3-.24-.54-.54-.54zM11.301 16.241a.28.28 0 01-.28-.28v-6.19h-1.2a.28.28 0 01-.28-.28c0-.15.12-.29.28-.29h1.48c.16 0 .28.13.28.28v6.47c0 .17-.13.29-.28.29z"}}),_c('path',{attrs:{"d":"M13.281 16.242h-3.97a.28.28 0 110-.56h3.97c.16 0 .28.13.28.28.01.16-.12.28-.28.28z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.361 .312)","d":"M0 0h21.88v21.88H0z"}})])])])
          )
        }
      }
    